import type { NovaCotacaoDialogProps } from "./types-nova-cotacao-dialog";
import { useNovaCotacaoDialog } from "./use-nova-cotacao-dialog";
import { NovaCotacaoDialogView } from "./view-nova-cotacao-dialog";

export function NovaCotacaoDialog(props: NovaCotacaoDialogProps) {
  const vm = useNovaCotacaoDialog(props);

  return <NovaCotacaoDialogView {...vm} />;
}

export type * from "./types-nova-cotacao-dialog";
